import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
  APP_INITIALIZER
} from "@angular/core";
import { provideRouter, withViewTransitions } from "@angular/router";
import { routes } from "./app.routes";
import { provideStore } from "@ngrx/store";
import { provideEffects } from "@ngrx/effects";
import { provideStoreDevtools } from "@ngrx/store-devtools";
import { effects, metaReducers, reducers } from "./store";
import { provideHttpClient, withInterceptorsFromDi, withFetch } from "@angular/common/http";
import {
  provideAnimations
} from "@angular/platform-browser/animations";
import { MsalProvidersModule } from "./core/auth/msal/msal.module";
import { TranslateModule, TranslateService } from "@ngx-translate/core"
import { graphqlProvider } from './core/graph/graph_provider_ng17/graphql.provider';
import { AuthService } from "./core/auth/auth.service";
import { MessageService } from 'primeng/api';
import { InterceptorModule } from "./interceptors/interceptor.module";
import { initializeModulePermissions } from './core/initializers/module-permissions.initializer';

/***
** @params 'MsalProvidersModule' :  MSAL module implementation for ENTRAID connection
** @params 'GraphQlModule' : GraphQl module implementation for new HttpStandard in Angular version older than 16
** @params 'graphqlProvider' : GraphQl module implementation for new HttpStandard in Angular version older than 16
** all module that wee need to provide are in 'importProvidersFrom(MsalProvidersModule, GraphQlModule)',
***/
// 

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withViewTransitions()),
    provideAnimations(),
    provideStore(reducers, { metaReducers }),
    provideEffects(effects),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    graphqlProvider,
    TranslateService,
    AuthService,
    // provideZoneChangeDetection({ eventCoalescing: false }),
    importProvidersFrom(MsalProvidersModule, TranslateModule, InterceptorModule),
    provideStoreDevtools({ maxAge: 30, logOnly: !isDevMode() }),
    MessageService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeModulePermissions,
      multi: true
    }
  ]
};
